<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Link Ends with Interference</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div #preloaderTarget class="preloader-target">
        <div *ngIf="nodesNumber" class="modal-body modal-body--fixed-header">
            <div class="modal-body__fixed-header">
                <winde-tabs-nav
                        (tabChanged)="changeTab($event)"
                        *ngIf="tabsToShow && tabsToShow.length > 0"
                        [activeTab]="currentTab"
                        [customClass]="'tabs-nav--doc-tabs mb-1 report-tabs'"
                        [tabsList]="tabsToShow"
                        [translationPrefix]="'project.reportsTabs'"
                >
                </winde-tabs-nav>
            </div>
            <div class="modal-body__scroll-content pt-3">
                <h6 class="devices-list-title mb-3">Locations ({{ nodesListToShow ? nodesListToShow.length : 0 }})</h6>
                <ul class="list-unstyled">
                    <li *ngFor="let node of nodesListToShow; trackBy: trackNodeName">
                        <h6>
                            <winde-node-pointer
                                    [listData]="{ nodeNames: node.nodeName, placement: 'top', cropName: 20 }"
                            ></winde-node-pointer>
                            <button (click)="showNode = showNode !== node.nodeName ? node.nodeName : undefined" windeActionIcon>
                                <sui-svg-icon [icon]="showNode === node.nodeName ? 'angle-up' : 'angle-down'" windeGrey/>
                            </button>
                        </h6>
                        <div *ngIf="showNode === node.nodeName" class="grid">
                            <!-- HEADER -->
                            <div class="grid-row">
                                <div class="grid-row__cell">Remote Location (link)</div>
                                <div class="grid-row__cell ratio">C/I ratio</div>
                                <div *ngIf="layers" class="grid-row__cell">Layer</div>
                                <div class="grid-row__cell state-cell">Frozen / Installed</div>
                            </div>

                            <!-- BODY -->
                            <div
                                    *ngFor="let secondNode of node.secondNodesList; trackBy: trackNodeName"
                                    [ngClass]="{ 'highlight-substring--blue': secondNode.selected }"
                                    class="grid-row"
                            >
                                <div class="grid-row__cell">
                                    <winde-node-pointer
                                            (click)="selectLink(node.nodeName, secondNode.nodeName)"
                                            (keydown)="selectLink(node.nodeName, secondNode.nodeName)"
                                            [listData]="{ nodeNames: secondNode.nodeName, placement: 'top', cropName: 10 }"
                                    ></winde-node-pointer>
                                    (
                                    <winde-link-pointer
                                            (click)="selectLink(node.nodeName, secondNode.nodeName)"
                                            (keydown)="selectLink(node.nodeName, secondNode.nodeName)"
                                            [linkData]="{
                                            nodeFrom: node.nodeName,
                                            nodeTo: secondNode.nodeName,
                                            name: 'link'
                                        }"
                                    ></winde-link-pointer>
                                    )
                                </div>
                                <div class="grid-row__cell ratio">{{ secondNode.ciRatio }}</div>
                                <div *ngIf="layers" class="grid-row__cell">{{ layers[secondNode.layerIndex] }}</div>
                                <div class="grid-row__cell state-cell">
                                    @if (secondNode.isUserForced && !secondNode.isInstalled) {
                                        <button windeActionIcon>
                                            <sui-svg-icon icon="lock" windeGrey/>
                                        </button>
                                    }
                                    @if (secondNode.isUserForced && secondNode.isInstalled) {
                                        <button windeActionIcon>
                                            <sui-svg-icon icon="podcast" windeGrey/>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
